export enum ToolsEnum {
    layersPanel = 'layersPanel',
    internalLayersPanel = 'internalLayersPanel',
    externalLayersPanel = 'externalLayersPanel',
    mapLayersPanel = 'mapLayersPanel',

    geocoder = 'geocoder',
    reposition = 'reposition',
    carSelector = 'carSelector',
    streetInfo = 'streetInfo',
    annotationsLayer = 'annotationsLayer'
}

export const FULL_TOOLS_ALLOWED: ToolsEnum[] = [
    ToolsEnum.layersPanel,
    ToolsEnum.internalLayersPanel,
    ToolsEnum.externalLayersPanel,
    ToolsEnum.mapLayersPanel,

    ToolsEnum.geocoder, 
    ToolsEnum.reposition,
    ToolsEnum.carSelector,
    ToolsEnum.streetInfo,
    ToolsEnum.annotationsLayer
];